const idSeparator = "/@@/";
function getStringifiedItemIds(items) {
  return placeSeparatorAtEnds(items.map((item) => item.item.id.toString()).join(idSeparator));
}
function placeSeparatorAtEnds(stringifiedIds) {
  return `${stringifiedIds.startsWith(idSeparator) ? "" : idSeparator}${stringifiedIds}${stringifiedIds.endsWith(idSeparator) ? "" : idSeparator}`.trim();
}
function getIdsFromStringifiedIds(stringifiedIds) {
  return stringifiedIds.split(idSeparator).filter((id) => id !== "");
}
function removeSeparators(id) {
  return id.replace(new RegExp(idSeparator, "g"), "");
}
export {
  getIdsFromStringifiedIds,
  getStringifiedItemIds,
  idSeparator,
  placeSeparatorAtEnds,
  removeSeparators
};
//# sourceMappingURL=stringifiedItemIdsHelpers.js.map
